import React from 'react';
import { Menu, Search, X } from 'lucide-react';
import { useNavigation } from '../hooks';
import { useReportContext } from '../contexts';
import bowLogo from '../logos/bow.svg';

export const Navigation = ({ navigateTo, activePage, newsSearchQuery = '', setNewsSearchQuery, toggleMenu, isMenuOpen }) => {
  const { scrollToElement } = useNavigation();
  const { clearReport } = useReportContext();

  const handleSectionNavigation = (sectionId) => {
    scrollToElement(sectionId);
  };

  const NavLinks = ({ isMobile = false }) => (
    <div className={`flex ${isMobile ? 'flex-col gap-6' : 'flex-row gap-10'} items-center`}>
      <button
        onClick={() => {
          clearReport();
          navigateTo('services');
          if (isMobile) toggleMenu();
        }}
        className={`hover:text-zinc-500 transition-all uppercase tracking-[0.15em] text-[10px] font-medium ${activePage === 'services' ? 'text-zinc-900 border-b border-zinc-900 pb-1' : 'text-zinc-500'
          } ${isMobile ? 'text-xl text-left block w-full' : ''}`}
      >
        Services
      </button>
      <button
        onClick={() => {
          clearReport();
          navigateTo('news');
          if (isMobile) toggleMenu();
        }}
        className={`hover:text-zinc-500 transition-all uppercase tracking-[0.15em] text-[10px] font-medium ${activePage === 'news' ? 'text-zinc-900 border-b border-zinc-900 pb-1' : 'text-zinc-500'
          } ${isMobile ? 'text-xl text-left block w-full' : ''}`}
      >
        News
      </button>
      <button
        onClick={() => { 
          clearReport();
          navigateTo('intelligence'); 
          if (isMobile) toggleMenu(); 
        }}
        className={`hover:text-zinc-500 transition-all uppercase tracking-[0.15em] text-[10px] font-medium ${activePage === 'intelligence' ? 'text-zinc-900 border-b border-zinc-900 pb-1' : 'text-zinc-500'
          } ${isMobile ? 'text-xl text-left block w-full' : ''}`}
      >
        Intelligence
      </button>
    </div>
  );

  const NewsSearch = ({ isMobile = false }) => {
    if (activePage !== 'news' || !setNewsSearchQuery) return null;

    return (
      <label className={`relative block ${isMobile ? 'w-full' : 'w-64 lg:w-80'}`}>
        <Search
          size={15}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400"
        />
        <input
          value={newsSearchQuery}
          onChange={(event) => setNewsSearchQuery(event.target.value)}
          placeholder="Search news"
          className="h-10 w-full rounded-full border border-zinc-200 bg-white pl-9 pr-4 text-sm text-zinc-900 outline-none transition placeholder:text-zinc-400 focus:border-zinc-900"
        />
      </label>
    );
  };

  return (
    <nav className="fixed w-full z-40 bg-[#fcfaf7] border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
        {/* Logo */}
        <div
          onClick={() => navigateTo('landing')}
          className="flex items-center group cursor-pointer"
        >
          <img
            src={bowLogo}
            alt="Panometra"
            className="h-6 sm:h-8 w-auto hover:opacity-80 transition-all duration-300 transform group-active:scale-95"
          />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-10">
          <NavLinks isMobile={false} />
          <NewsSearch />
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-zinc-900" onClick={toggleMenu}>
          {isMenuOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-16 sm:top-20 left-0 w-full bg-[#fcfaf7] border-b border-zinc-200 px-6 py-12 flex flex-col gap-10 text-zinc-900 shadow-2xl animate-in">
          <NewsSearch isMobile={true} />
          <NavLinks isMobile={true} />
        </div>
      )}
    </nav>
  );
};
